import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SupplierException } from 'src/app/shared/models/supplier-exception';
import { ConstantService } from '../../../shared/services/constant-service/constant.service';
import { DataService } from 'src/app/shared/services/data-service/data.service';

@Component({
  standalone: false,
  selector: 'exception-table-row',
  templateUrl: './exception-table-row.component.html',
  styleUrls: ['./exception-table-row.component.scss'],
})
export class ExceptionTableRowComponent implements OnInit {
  @Input() exception!: SupplierException;
  @Input() id: number = 0;
  @Input() isViewOnly: boolean = false;
  @Input() error: string = '';
  @Input() allExceptions: SupplierException[] = [];
  @Output() deleteException = new EventEmitter<SupplierException>();
  @Output() updateException = new EventEmitter<SupplierException>();
  @Output() selectedValueChange = new EventEmitter<SupplierException>();

  exceptionPair = ConstantService.exceptionPair;
  exceptionValues?: string[];
  formattedExceptionValue: string;
  previousState: string;
  statesEl: HTMLSelectElement;

  constructor(private dataService: DataService) {}

  async ngOnInit(): Promise<void> {
    if (this.exception) {
      this.populateExceptionValues(this.exception.criteria);
      this.formattedExceptionValue = this.exception.value;
      if (this.exception.criteria === 'Material Exclusion') {
        const materialDescrption =
          await this.dataService.getMaterialDescription(this.exception.value);
        this.formattedExceptionValue = `${this.exception.value} - ${materialDescrption}`;
      }
    }
  }

  onSelectedValueChange(e: any) {
    this.selectedValueChange.emit(e);
  }

  onExceptionSelected(e: any) {
    if (!e.target.value) return;
    // Case user change existing exption to be the duplicate, system not allow and rollback selected value

    if (
      this.isDuplicateException(e.target.value) &&
      this.previousState !== 'New'
    ) {
      alert(`Cannot add duplicate exception criteria: ${e.target.value}!`);
      this.exception.criteria = this.previousState;
      this.statesEl.selectedIndex = this.exceptionPair.findIndex(
        (x) => x.criteria === this.previousState
      );
      return;
    }

    // Populate exception value
    this.populateExceptionValues(e.target.value);
    this.exception.value = this.exceptionValues![0];

    // Emit event back to parent
    this.updateException.emit(this.exception);
  }

  onExceptionStateSelected(
    previousState: any,
    state: any,
    statesEl: HTMLSelectElement
  ) {
    if (!state) return;

    this.previousState = previousState;
    this.statesEl = statesEl;
  }

  isDuplicateException(exception: string): boolean {
    let found = false;
    if (exception === 'Material Exclusion') return false;

    if (
      this.allExceptions.filter((item) => {
        return item.criteria === exception && !item.isDeleted;
      }).length > 1
    ) {
      found = true;
    }

    return found;
  }

  onExceptionValueSelected(selectedExceptionValue: any) {
    if (!selectedExceptionValue.target.value) return;

    this.updateException.emit(this.exception);
  }

  onDelete(e: any) {
    this.deleteException.emit(this.exception);
  }

  populateExceptionValues(value: string) {
    this.exceptionValues = this.exceptionPair.find((exception) => {
      if (exception.criteria == value) {
        return exception.value;
      }
      return;
    })?.value;
  }
}

